import styled, { css } from 'styled-components';

import { StyledProps } from '../../../types';
import CalendarIconSVG from 'src/assets/calendar-icon.svg';
import CalendarEmptyIconSVG from 'src/assets/calendar-no-number-icon.svg';
import PeaceIconSVG from 'src/assets/peace-icon.svg';
import SmileyIconSVG from 'src/assets/smiley-icon.svg';
import ZeroFeeIconSVG from 'src/assets/zero-fee.svg';
import {
  CARD_BREAKPOINT,
  colors,
  MOBILE_BREAKPOINT,
} from 'src/commons/constants';

export const FeatureListRowContainer = styled.div`
  width: 100%;
  max-width: 31.5rem;
  height: auto;
  margin: 1.75rem 0 2.3125rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  @media (max-width: ${CARD_BREAKPOINT}) {
    max-width: 18rem;
    margin: 2.1875rem 0 2.6875rem;
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 1.4375rem 0 1.875rem;
  }
`;

export const FeatureListColumnContainer = styled.div`
  width: 100%;
  max-width: 20.125rem;
  height: auto;
  margin: 1.75rem 0 2.3125rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

export const FeatureColumnContainer = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: ${CARD_BREAKPOINT}) {
    flex-direction: row;
    margin: 0 0 2rem 0;
    ${(p: StyledProps) =>
      p.variant === 'b' &&
      `
      margin: 0 0 1.125rem 0;
    `};
    ${(div: StyledProps) =>
      div.lastListItem &&
      ` 
      margin: 0;
    `};
  }
`;

export const FeatureRowContainer = styled.div<StyledProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 1.375rem;
  margin: 0 0 1.125rem 0;
  ${(div: StyledProps) =>
    div.lastListItem &&
    ` 
    margin: 0;
  `};
`;

export const AutoPayFeatureText = styled.p<StyledProps>`
  max-width: 9.25rem;
  margin: 0.875rem 0 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  text-align: center;
  color: ${colors.TEXT_PRIMARY};
  ${(p: StyledProps) =>
    p.firstListItem &&
    p.variant === 'control' &&
    `
    margin: 0.375rem 0 0;
  `};
  ${(p: StyledProps) =>
    p.variant === 'a' &&
    `
    font-size: 1rem;
    max-width: 17.813rem;
    margin: 0;
  `};
  ${(p: StyledProps) =>
    p.variant === 'b' &&
    ` 
    max-width: 8.188rem;
  `};
  @media (max-width: ${CARD_BREAKPOINT}) {
    max-width: 14rem;
    text-align: left;

    ${(p: StyledProps) =>
      p.variant === 'a' &&
      `
        max-width: 17.813rem;
        margin: 0;
      `};

    ${(p: StyledProps) =>
      p.variant === 'b' &&
      `
        font-size: 1rem;
        max-width: 14.5rem;
        margin: 0;
      `};
  }
`;

export const FeatureIconStyle = css`
  height: 2.125rem;
  width: 2.125rem;
  min-height: 2.125rem;
  min-width: 2.125rem;
  margin: 0;
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin: 0 1.5rem 0 0;
  }
`;

export const SmallFeatureIconStyle = css`
  height: 1.25rem;
  width: 1.25rem;
  min-height: 1.25rem;
  min-width: 1.25rem;
  margin: 0 1rem 0 0;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0 0.688rem 0 0;
  }
`;

export const CalendarFilledIcon = styled(CalendarIconSVG)`
  ${FeatureIconStyle}
`;

export const CalendarEmptyIcon = styled(CalendarEmptyIconSVG)`
  ${SmallFeatureIconStyle}
`;

export const PeaceIcon = styled(PeaceIconSVG)`
  ${FeatureIconStyle}
`;

export const SmileyIcon = styled(SmileyIconSVG)`
  ${FeatureIconStyle}
`;

export const SmallSmileyIcon = styled(SmileyIconSVG)`
  ${SmallFeatureIconStyle}
`;

export const ZeroFeeIcon = styled(ZeroFeeIconSVG)`
  ${FeatureIconStyle}
  height: 2.625rem;
`;

export const SmallZeroFeeIcon = styled(ZeroFeeIconSVG)`
  ${SmallFeatureIconStyle}
  height: 2.625rem;
`;
